// extracted by mini-css-extract-plugin
export var twitterBox = "twitter-box-module--twitterBox--37dCV";
export var twitterBoxText = "twitter-box-module--twitterBoxText--3R8KZ";
export var twitterBoxTitle = "twitter-box-module--twitterBoxTitle--1f19M";